/**
 * Usage: call .inlineEdit() on an input, select or textarea
 */
(function($) {
	$.widget('ui.inlineEdit', {
		
		options: {
			revertTitle: 'Discard change (revert to: {1})',
			disabled: false
		},
		
		defaultValue: null,
		editStartValue: null,
		target: null,
		placeholder: null,
		placeholderText: null,
		targetClass: null,
		
		_init: function(){
			this.target = this.element;
			this.targetClass = 'ui-inline-edit-target-' + Math.round(Math.random() * 1000);
			this.defaultValue = this.getValue();
			
			// styling
			this.target.addClass('ui-inline-edit-target')
					   .addClass(this.targetClass);
			
			// create placeholder
			this.placeholder = $('<span class="ui-inline-edit-placeholder">'+
									'<a href="#" class="ui-inline-edit-placeholder-text">'+
										this._getPlaceholderText(this.defaultValue)+
									'</a> '+
									'<span class="ui-icon ui-icon-inline-edit-revert">'+
									'</span>'+
								 '</span>')
								 .insertAfter(this.target);
			this.placeholderText = this.placeholder.children('.ui-inline-edit-placeholder-text');
			this._setRevertIconTitle();
			
			// bind listeners (can be unbound/rebound etc)
			this._bindPlaceholderListeners();
			this._bindDefaultTargetListeners();
		},
		
		_bindPlaceholderListeners: function(){
			var self = this;
			// placeholder hover styles
			this.placeholderText.hover(
				function(){ self.placeholder.addClass('ui-inline-edit-hover'); },
				function(){ self.placeholder.removeClass('ui-inline-edit-hover'); }
			);
			// placeholder open on click
			this.placeholderText.click(function(event){
				// prevent hash thing
				event.preventDefault();
				self.open();
			});
			// revert icon
			this.placeholder.children('.ui-icon-inline-edit-revert').click(function(){
				self.revert();
			});
		},
		
		_bindDefaultTargetListeners: function(){
			var self = this;
			// on target change update placeholder
			this.target.change(function(){
				self.change.call(self);
			});
			// placeholder close
			if(this.target.is('input,select,textarea')){
				this.target.blur(function(event){
					self.close();
				});
			};
		},
		
		getValue: function(){
			if(this.element.is('input,select,textarea')){
				return this.element.val();
			}else{
				return this.element.text();
			}
		},
		
		setValue: function(value){
			if(this.element.is('input,select,textarea')){
				this.element.val(value);
			}else{
				this.element.text(value);
			}
			this.target.change();
		},
				
		// method: set current value as the default, changes may be reverted by the user
		setIsDefault: function(){
			this.defaultValue = this.getValue();
			this.placeholder.removeClass('ui-inline-edit-changed');
			this._setRevertIconTitle();
			this.target.change();
		},
		
		_setRevertIconTitle: function(){
			this.placeholder.find('.ui-icon-inline-edit-revert').attr('title', this.options.revertTitle.replace('{1}', this._getPlaceholderText(this.defaultValue)));
		},
		
		// TODO: rename, returns html
		_getPlaceholderText: function(targetValue){
			if(this.target.is('input')){
				return targetValue;
			}else if(this.target.is('textarea')){
				return targetValue.replace(/\n\r?/g, '<br/>');
			}else if(this.target.is('select')){
				return $.trim(this.target.children('[value='+targetValue+']').text());
			}else{
				return targetValue;
			}
		},
		
		getText: function(){
			return this._getPlaceholderText(this.getValue());
		},
		
		isOpen: function(){
			return this.placeholder.hasClass('ui-inline-edit-editing');
		},
		
		open: function(){
			if(this._isOpen || this.options.disabled) return;
			
			// style
			this.placeholder.addClass('ui-inline-edit-editing');
			$('.'+this.targetClass).addClass('ui-inline-edit-editing');
			
			this.target.focus();
			// store target value as edit start
			this.editStartValue = this.getValue();
			
			// select all text in input
			if(this.target.is('input')){
				this.target.select();
			}
			
			// trigger inlineeditopen
			this._trigger('open');
		},
		
		close: function(){
			$('.'+this.targetClass).removeClass('ui-inline-edit-editing');
			this.placeholder.removeClass('ui-inline-edit-editing');
			
			// trigger inlineeditclose
			this._trigger('close');
		},
		
		revert: function(){
			if(this.options.disabled) return;
			
			this.setValue(this.defaultValue);
			this.target.change();		
			this._trigger('revert');
		},
		
		change: function(){
			this.placeholderText.html(this._getPlaceholderText(this.getValue()));
			this.placeholder.removeClass('ui-inline-edit-changed');
			if(this.defaultValue != null && this.defaultValue != this.getValue()){
				this.placeholder.addClass('ui-inline-edit-changed');
			}
		},
		
		disable: function(){
			this.placeholder.addClass('ui-inline-edit-disabled');
			this.options.disabled = true;
		},
		
		enable: function(){
			this.placeholder.removeClass('ui-inline-edit-disabled');
			this.options.disabled = false;
		}
			
	});

	
})(jQuery);